import { render, staticRenderFns } from "./selection-6.vue?vue&type=template&id=2710ec08&scoped=true&"
import script from "./selection-6.vue?vue&type=script&lang=js&"
export * from "./selection-6.vue?vue&type=script&lang=js&"
import style0 from "./selection-6.vue?vue&type=style&index=0&id=2710ec08&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2710ec08",
  null
  
)

export default component.exports